// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\ReviewRatingStatsResponse

export type ReviewRatingStatsApiResponse = {
	all: { averageRating: number; reviewCount: number };
	period: { averageRating: number; reviewCount: number };
	previousPeriod: { averageRating: number; reviewCount: number };
};

export type ReviewRatingStats = {
	all: { averageRating: number; reviewCount: number };
	period: { averageRating: number; reviewCount: number };
	previousPeriod: { averageRating: number; reviewCount: number };
};

export function hydrateReviewRatingStats(data: ReviewRatingStatsApiResponse): ReviewRatingStats {
	return { ...data };
}